import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'audit-back-dialog',
  templateUrl: './t_back-dialog.component.html',
  styleUrls: ['./back-dialog.component.less']
})
export class BackDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<BackDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  choose(choice)
  {
  	this.dialogRef.close(choice);
  }

}
